module.exports = __webpack_public_path__ + "img/sku-detail.25717a6.png";